import Vue from 'vue'
import Vuex from 'vuex'

import globals from './modules/globals'
import settings from './modules/settings'
import navigation from './modules/navigation'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    globals,
    settings,
    navigation,
  }
})
